// extracted by mini-css-extract-plugin
export default {"form":"SendLetterForm_form__7iS5v","submitButton":"SendLetterForm_submitButton__6xcLE","centered":"SendLetterForm_centered__o3euI"};